import React from "react";
import { MathOperatorChildrenType } from "../mathOperatorTypes";

const Wrapper = ({ children }: MathOperatorChildrenType) => {
  return <div className='tw-w-[330px] tw-h-[224px] tw-top-[397px] tw-left-[811px] tw-p-[10px] tw-border-[1px] tw-rounded-sm tw-border-solid bg-gray-100'>{children}</div>;
};

export default Wrapper;